module.exports = __webpack_public_path__ + "img/file-earmark-play-fill.c06111d2.svg";